<template>
    <v-card class="p-4 w-100 h-0 delegation">
        <div class="d-flex align-items-center" v-if="!showAdvancedSearchDialog && !utils.CheckIfNullOrEmpty(filters)">
            <v-icon class="mx-1" style="width: 25px;">mdi-magnify</v-icon>
            <v-text-field class="m-0 align-items-center" v-model="filters.subject" solo
                          :label="$t('res_Label_SearchPlaceHolder') + ' ' + $t('res_GridHeaders_CreatedSubject')  + ' ... '"
                          @click:prepend="refreshPageGrid()" @keydown.enter="refreshPageGrid()">
            </v-text-field>
            <v-btn dense @click="refreshPageGrid()" class="primary ml-4">{{ $t("res_ButtonText_Search") }}</v-btn>
            <v-btn class="primary ml-4" @click="showAdvancedSearchDialog = !showAdvancedSearchDialog"><v-icon>mdi-chevron-down</v-icon></v-btn>
        </div>
        <div :style="{ display: showAdvancedSearchDialog ? 'block' : 'none' }">
            <AdvancedSearchFilters :filter="filters" 
                                   :applyFiltersOnReset="true"
                                   @applyFilters="applyFilters">
            </AdvancedSearchFilters>
        </div>
        <div class="d-flex ml-auto mt-1">
            <v-btn  v-if="showAdvancedSearchDialog"  dense   @click="showAdvancedSearchDialog = !showAdvancedSearchDialog"
                        class="expand-advance-search light-blue mr-2"><v-icon> mdi-chevron-up </v-icon></v-btn>
        </div>
        <div>
            <div class="p-0 flex-1 overflow-auto">
                <div class="tab-content mt-4">
                    <div class="panel">
                        <div class="row m-auto">
                            <div :class="{ 'custom-col col-lg-7 col-xl-6 p-0 pr-5': openPreviewPane, 'col-md-12 p-0': !openPreviewPane }">
                                <v-layout column>
                                    <v-flex class="position-relative sm-margin mt-2" md12>
                                        <!--table-->
                                        <!-- remove single-select in sprint 2 -->
                                        <v-data-table :mobile-breakpoint="0" :headers="grid_headers" v-model="selected"
                                                      :items="correspondences" :item-key="shouldShowExpand() ? 'documentId' : 'id'" :items-per-page="pagingData.pageSize"
                                                      hide-default-footer class="elevation-1" :show-select=false
                                                      single-select :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                                      :item-class="getRowClass" @dblclick:row="openFullView"
                                                      @click:row="previewCorrespondence" @item-selected="itemSelected"
                                                      @update:sort-by="updateSortBy" @update:sort-desc="updateSortDesc" must-sort
                                                      :show-expand="shouldShowExpand()" :expanded.sync="expanded" 
                                                      single-expand expand-icon="mdi-menu-down">
                                            
                                            <template v-slot:expanded-item="{ item }">
                                                <td colspan="100%" style="padding-left: 0px !important; padding-right: 0px !important;">
                                                    <div class="expanded-item-container">
                                                        <v-data-table
                                                            class="expanded-item-table"
                                                            :headers="filteredHeaders"
                                                            :items="getDynamicList(item)"
                                                            :item-class="getRowClass"
                                                            hide-default-footer
                                                            @click:row="previewCorrespondence">
                                                            <template v-slot:item.sentTo="{ item }">
                                                                {{ item.sentTo ?? item.recipient }}
                                                            </template>
                                                        </v-data-table>
                                                    </div>
                                                </td>                                 
                                            </template>
                                            
                                            <!--pin-->
                                            <template v-slot:item.pinned="{ item }">
                                                <v-icon @click="item.pinned = !item.pinned">{{ getPinned(item) }} </v-icon>
                                            </template>
                                            <!--overdue-->
                                            <template v-slot:item.overdue="{ item }">
                                                <label class="float-end text-warning mx-2">
                                                    <v-icon>{{ utils.getOverDue(item.overdue, nodeId) }}</v-icon> {{
                                                        utils.getOverdueDays(item.overdue, item.overdueDays, nodeId)
                                                    }}
                                                </label>
                                            </template>
                                            <!--status-->
                                            <template v-slot:item.status="{ item }">
                                                <v-chip dark v-bind:class=getStatusClass(item)>
                                                    {{ item.status }}
                                                </v-chip>
                                            </template>
                                            <!--attachment-->
                                            <template v-slot:item.hasAttachment="{ item }">
                                                <v-icon>{{ getAttachment(item.hasAttachment) }}</v-icon>
                                            </template>
                                            <template v-slot:item.subject="{ item }">
                                                <a :id="'ellipsisElements_1_' + item.id" class="td-text-limit"
                                                   @click="previewCorrespondence(item)">
                                                    <span>{{ item.subject }}</span>
                                                </a>
                                                <a :id="'ellipsisElements_2_' + item.id" class="td-text-limit"
                                                   style="text-wrap:wrap" v-tooltip="item.subject"
                                                   @click="previewCorrespondence(item)">
                                                    <span>{{ item.subject }}</span>
                                                </a>
                                            </template>
                                            <template v-slot:item.sender="{ item }">
                                                <span class="text-limit" v-tooltip="item.sender">{{ item.sender }}</span>
                                            </template>
                                            <template v-slot:item.recievedDate="{ item }">
                                                {{constants.showDateWithTime? utils.formatDateTimeWithTime(item.recievedDate) : utils.formatDateTime(item.recievedDate)  }}                                          
                                            </template>
                                            <template v-slot:item.createdDate="{ item }">
                                                {{ utils.formatDateTime(item.createdDate) }}
                                            </template>
                                            <template v-slot:item.dueDate="{ item }">
                                                {{ utils.formatDateTime(item.dueDate) }}
                                            </template>
                                            <template v-slot:no-data>
                                                <div class="flex-1">
                                                    <img src="/assets/images/empty-inbox.svg" alt="" />
                                                    <p class="m-0">
                                                        {{ $t("res_Msgs_GetAllCaughtUp") }}
                                                        <br>
                                                        {{ $t("res_Msgs_NoNewItem") }}
                                                    </p>
                                                </div>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <div :class="{ 'custom-col col-lg-5 col-xl-6 p-0 py-2': openPreviewPane }"
                                 v-if="openPreviewPane">
                                <div class="h-100"
                                     style="background: #EFF2F5; border-radius: 12px; position: relative; overflow: hidden">
                                    <div>
                                        <v-btn class="close-btn d-block bg-white close-viewer " icon
                                               @click="closePreview()">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </div>
                                    <!--viewer section-->
                                    <div class=" position-relative viewer-container scrollable-container"
                                         style="height: calc(100vh - 176px - 1rem); overflow-y: hidden;">
                                        <div v-if="empty_viewer" class="empty-viewer"
                                             style="border-radius: 12px; height: calc(100vh - 176px);">
                                            <img src="/assets/images/icons/template.svg" />
                                            <img src="/assets/images/icons/no_preview.svg" />
                                            <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                                        </div>
                                        <div v-if="!empty_viewer" id="viewer_template" class="h-100"
                                             style="border-radius: 12px;">
                                            <iframe id="viewerFrame" :src="viewerFrame" class="w-100"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog"
                  fullscreen v-bind:persistent="nodeId == 1">
            <div id="correspondenceDialogEmptyDiv"></div>
            <CreateDocumentView :documentId="documentId" :transferId="transferId" :viewMode="viewMode"
                                :delegationId="delegationId" :toEmail="toEmail" :emailCC="emailCC"
                                :closeDialogEvent="closeCorrespondenceDialog" :openedFromNodeId="nodeId" />
        </v-dialog>
        <div class="d-flex align-items-center mt-2">
            <Pagination :totalCount="inboxes[0].count" :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex"
                        @pageIndexChanged="pageIndexChanged" :showPageSize="false" :showMargin="false"></Pagination>
            <div v-if="this.inboxes[0].count">
                <v-btn class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')"><v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon></v-btn>
                <v-btn class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')"><v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon></v-btn>
            </div>
        </div>
        <v-dialog :style="{ display: showDynamicFormsFilterDialog ? 'block' : 'none' }" content-class="dialog2 address-book-dialog with-fixed-actions">
            <div class="dialog-header" style="z-index: 3000 !important;">
                <h1>{{ $t('res_Label_MoreFilters') }}</h1>
            </div>
            <div class="dialog-body white-container p-4">
                <DynamicFormRender ref="formStructureAndCategory" :formId="dynamicFormByStructureIdAndCategoryId" :filters="filterByStructureIdAndCategoryId"></DynamicFormRender>
                <div v-for="(item, index) in templateRenderObjects">
                    <DynamicFormRender :ref="'dynamicForm_' + index" :formId="item.dynamicFormByTemplateId" :filters="item.filterByTemplateId"></DynamicFormRender>
                </div>
            </div>
            <v-card-actions class="gap-2 sticky-actions flex-row-reverse">
                <v-btn class="primary" style="min-width: 100px !important" @click="applyMoreFilters()"> {{ $t("res_ButtonText_Apply") }} </v-btn>
            </v-card-actions>
        </v-dialog>

    </v-card>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'
    import CreateDocumentView from '@/views/CreateDocumentView.vue'
    import { defaultGet } from '@/assets/js/common.js'
    import TransferForm from '@/components/TransferForm.vue'
    import SigningHistory from '@/components/SigningHistory.vue'
    import TrackingTree from '@/components/TrackingTree.vue'
    import * as utils from '@/assets/js/common.js'
    import NotifyEmail from '@/components/NotifyEmail.vue'
    import DispatchLetter from '@/components/DispatchLetter.vue'
    import Sign from '@/components/Sign.vue'
    import Pagination from '@/components/Pagination.vue'
    import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import Multiselect from 'vue-multiselect'
    import DynamicFormRender from '@/components/DynamicFormRender.vue';
    import router from '../router/index.js';
    import AdvancedSearchFilters from '@/components/AdvancedSearchFilters.vue';

    export default {
        name: 'AdvancedSearch',
        components: { Multiselect, StructureUserSelector, CreateDocumentView, TransferForm, SigningHistory, TrackingTree, NotifyEmail, DispatchLetter, Sign, Pagination, TransferNotesIcon, DynamicFormRender, AdvancedSearchFilters },
        props:
        {
            nodeId: { type: Number, default: 2 }
        },
        data() {
            const vm = this;
            return {
                router: router,
                isLanguageEn: true,
                offset: true,
                loading: false,
                action_types: [],
                from_date_datePicker: false,
                to_date_datePicker: false,
                hideSpinner: false,
                isExport: false,
                exportType: '',
                structureCategories: [{ id: '1', name: 'Incoming' }, { id: '2', name: 'Outgoing' }, { id: '3', name: 'Internal' }],
                privacies: [],
                priorities: [],

                /*sort by pinned*/
                sortBy: 'id',
                sortDesc: true,

                selected_node_id: 0,
                correspondences: [],
                nonGroupedCorrespondences: [],
                selectedItem: null,
                selected: [],
                grid_headers: [],
                openPreviewPane: false,
                viewerFrame: '',
                empty_viewer: true,

                inboxes: [{ id: 1, name: 'My Inbox', inboxId: 1, delegationId: 0, count: 0 }],
                selected_node: {},
                selected_index: 0,
                delegationId: 0,
                correspondenceDialog: false,
                documentId: 0,
                transferId: 0,
                viewMode: 'readonly',
                referenceNumber: "",
                toEmail: "",
                emailCC: "",
                utils: utils,
                constants: constants,
                pagingData: {
                    pageSize: 20,
                    pageIndex: 0
                },

                //dynamicFormsFilter
                dynamicFormByStructureIdAndCategoryId: 'dynamicFormByStructureIdAndCategoryId',
                filterByStructureIdAndCategoryId: {} = { id: '', templateName: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: 0, url: constants.baseApiUrl, isEditable: 1 },
                templateRenderObjects: [],
                showDynamicFormsFilterDialog: false,
                showStructureFormRender: true,
                showTemplateFormsRender: true,
                currentUserStructureId: 0,
                nowDate: new Date().toISOString().slice(0, 10),
                showAdvancedSearchDialog: false,
                filters : {
                    subject: "",
                    referenceNumber: "",
                    fromDate: "",
                    toDate: "",
                    fromStructure: { id: 0, isUser: false, name: '' },
                    toStructure: { id: 0, isUser: false, name: '' },
                    fromUser: { id: 0, name: '' },
                    toUser: { id: 0, name: '' },
                    category: { id: 0, text: '' },
                    privacyLevel: { id: 0, name: '' },
                    priorityLevel: { id: 0, name: '' },
                    status: { id: 0, name: '' },
                    purpose: { id: 0, name: '' },
                    receivedDate :"",
                    content: "",
                    tags: "",
                    links: "",
                    template: { id: 0, name: '' },
                    note: "",
                    RejectedByMe: false,
                    ArchivedByMe: false,
                    SignedByMe: false,
                    isDynamicFormsFiltered: false,
                    dynamicFormFilter_byStructure: null,
                    dynamicFormFilter_byTemplate: null
                },
                expanded: [],
                expanded_headers: [
                    { text: this.$t('res_GridHeaders_ActionType'), value: 'purpose', sortable: false },
                    { text: this.$t('res_GridHeaders_DueDate'), value: 'dueDate', sortable: false },
                    { text: this.$t('res_GridHeaders_FromUser'), value: 'senderUser', sortable: false },
                    { text: this.$t('res_GridHeaders_FromStructure'), value: 'sender', sortable: false },           
                    { text: this.$t('res_Label_Status'), value: 'status', sortable: false },
                    { text: this.$t('res_GridHeaders_Recieved'), value: 'recievedDate', sortable: false }
                ],
                expanded_headers_sent: [
                    { text: this.$t('res_GridHeaders_ActionType'), value: 'purpose', sortable: false },
                    { text: this.$t('res_GridHeaders_DueDate'), value: 'dueDate', sortable: false },           
                    { text: this.$t('res_GridHeaders_ToUser'), value: 'sentTo', sortable: false },
                    { text: this.$t('res_GridHeaders_ToStructure'), value: 'recipient', sortable: false },
                    { text: this.$t('res_Label_Status'), value: 'status', sortable: false },
                    { text: this.$t('res_GridHeaders_Recieved'), value: 'recievedDate', sortable: false }
                ]
            };
        },
        beforeMount() {
           
        },
        mounted() {
            this.inboxes = [{ id: 1, name: window.translate("res_TabsName_Inbox"), inboxId: 1, delegationId: 0, count: 0 }]
            this.grid_headers = [
                { text: window.translate("res_GridHeaders_CreatedSubject"), value: 'subject', sortable: false },
                { text: window.translate("res_GridHeader_ReferenceNumber"), value: 'referenceNumber', sortable: false },
                { text: window.translate("res_GridHeaders_DueDate"), value: 'dueDate', sortable: true },
                { text: window.translate("res_GridHeaders_ForwaredFrom"), value: 'fromUser', sortable: false },
                { text: window.translate("res_Label_Sender"), value: 'sender', sortable: false },
                { text: window.translate("res_Label_Privacy"), value: 'privacy', sortable: false },
                { text: window.translate("res_GridHeaders_ActionType"), value: 'purpose', sortable: false },
                { text: window.translate("res_Label_Status"), value: 'status', sortable: false },
                { text: window.translate("res_Label_RecievedOn"), value: 'recievedDate', sortable: true },
            ]

            // Add expand column if grouping is enabled
            if (this.shouldShowExpand()) {
                this.grid_headers.unshift({ text: this.$t('res_Label_Expand'), value: 'data-table-expand', width: '5px', sortable: false, show: true })
            }

            setTimeout(function () {
                var headers = document.querySelectorAll('.v-data-table-header th.sortable');
                headers.forEach(function (header) {
                    var span = header.querySelector('span');
                    var icon = header.querySelector('.v-data-table-header__icon');
                    span.append(icon);
                });
            }, 10)
           
            this.clearAndResetFilters();
            this.privacies = constants.privacies;
            this.priorities = constants.priorities;
            this.getUserStructures();

            if (this.$route.query.fromSession) {
                if (!utils.CheckIfNullOrEmpty(sessionStorage.getItem('advanced_search_filters'))) {
                    this.filters = utils.copyObject(JSON.parse(sessionStorage.getItem('advanced_search_filters')),this.filters);
                    sessionStorage.setItem('advanced_search_filters', '');
                }
            }

            this.applyFilters();
        },
        beforeDestroy() {
            sessionStorage.removeItem('advanced_search_filters');
        },
        methods: {
            applyFilters(updatedFilters) 
            {
                if (utils.CheckIfNullOrEmpty(updatedFilters)) 
                {
                    this.selected = []
                    this.selectedItem = null;
                    this.initPage(0)
                }
                else 
                {
                    this.filters = updatedFilters;
                    this.getItemsForSelectedInbox(true);
                }
            },
            clearAndResetFilters() {
                this.filters = {
                    subject: "",
                    referenceNumber: "",
                    fromDate: "",
                    toDate: "",
                    fromStructure: { id: 0, isUser: false, name: '' },
                    toStructure: { id: 0, isUser: false, name: '' },
                    fromUser: { id: 0, name: '' },
                    toUser: { id: 0, name: '' },
                    category: { id: 0, text: '' },
                    privacyLevel: { id: 0, name: '' },
                    priorityLevel: { id: 0, name: '' },
                    status: { id: 0, name: '' },
                    purpose: { id: 0, name: '' },
                    receivedDate :"",
                    content: "",
                    tags: "",
                    links: "",
                    template: { id: 0, name: '' },
                    note: "",
                    RejectedByMe: false,
                    ArchivedByMe: false,
                    SignedByMe: false,
                    isDynamicFormsFiltered: false,
                    dynamicFormFilter_byStructure: null,
                    dynamicFormFilter_byTemplate: null
                }
            },
            setStructure(item, type) {
                if (type == 1)
                    this.filters.fromStructure = item;
                else
                    this.filters.toStructure = item
            },
            setUser(selectedUserItem, type) {
                if (type == 1) {
                    this.filters.fromUser = selectedUserItem;
                    this.filters.fromUser.id = selectedUserItem.id.split('-')[0];
                }
                else {
                    this.filters.toUser = selectedUserItem;
                    this.filters.toUser.id = selectedUserItem.id.split('-')[0];
                }
            },
            exportToExcelOrPdf(exportType) {
                this.isExport = true;
                this.exportType = exportType;
                var extension = exportType == 1 ? '.xlsx' : '.pdf';
                var query = this.prepareSearchAndExportQuery();

                if (!this.hideSpinner)
                    window.showLoading();           

                axios({
                    url: constants.baseApiUrl + `Transfer/AdvancedSearch`,
                    method: 'POST',
                    responseType: 'blob',
                    data: query
                })
                    .then((res) => {
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch(() => { })
                    .finally(f => {
                        !this.hideSpinner ? window.hideLoading() : this.hideSpinner = !this.hideSpinner;
                    });
                this.isExport = false;
                this.exportType = '';
            },
            prepareSearchAndExportQuery() 
            {
                const queryObject = {};
               // if (!this.filters.enableAdvancedSearch) 
               // {
               //    this.filters.referenceNumber = this.filters.subject;
               // }

                queryObject.delegationId = !utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id)
                    ? this.selected_node.delegationId
                    : 0;

                queryObject.pageIndex = this.pagingData.pageIndex;
                queryObject.pageSize = this.pagingData.pageSize;
                queryObject.sortBy = this.sortBy;
                queryObject.sortDir = this.sortDesc ? 'desc' : 'asc';
                queryObject.enableAdvancedSearch = this.filters.enableAdvancedSearch;

                if (!utils.CheckIfNullOrEmpty(this.filters.subject)) {
                    queryObject.subject = this.filters.subject;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.referenceNumber)) {
                    queryObject.referenceNumber = this.filters.referenceNumber;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.fromDate)) {
                    queryObject.fromDate = this.filters.fromDate;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.toDate)) {
                    queryObject.toDate = this.filters.toDate;
                }

                if (this.filters.fromStructure.id > 0) {
                    queryObject.FromStructureId = this.filters.fromStructure.id;
                }

                if (this.filters.toStructure.id > 0) {
                    queryObject.toStructureId = this.filters.toStructure.id;
                }

                if (this.filters.fromUser.id > 0) {
                    queryObject.fromUserId = this.filters.fromUser.id;
                }

                if (this.filters.toUser.id > 0) {
                    queryObject.toUserId = this.filters.toUser.id;
                }

                if (this.filters.category.id > 0) {
                    queryObject.categoryId = this.filters.category.id;
                }

                if (this.filters.privacyLevel.id > 0) {
                    queryObject.privacyId = this.filters.privacyLevel.id;
                }

                if (this.filters.priorityLevel.id > 0) {
                    queryObject.priorityId = this.filters.priorityLevel.id;
                }

                if (this.filters.status.id > 0) {
                    queryObject.statusId = this.filters.status.id;
                }
                if (this.filters.purpose.id > 0) {
                    queryObject.purposeId = this.filters.purpose.id;
                }

                if (this.filters.template.id > 0) {
                    queryObject.templateId = this.filters.template.id;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.links)) {
                    queryObject.links = this.filters.links;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.tags)) {
                    queryObject.tags = this.filters.tags;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.content)) {
                    queryObject.content = this.filters.content;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.receivedDate)) {
                    queryObject.transferDate = this.filters.receivedDate;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.note) === false) {
                    queryObject.note = this.filters.note;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.dynamicFormFilter_byStructure)) {
                    queryObject.dynamicFormFilter_byStructure = this.filters.dynamicFormFilter_byStructure;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.dynamicFormFilter_byTemplate)) {
                    queryObject.dynamicFormFilter_byTemplate = this.filters.dynamicFormFilter_byTemplate;
                }

                queryObject.signedByMe = this.filters.SignedByMe;
                queryObject.archivedByMe = this.filters.ArchivedByMe;
                queryObject.rejectedByMe = this.filters.RejectedByMe;

                if (this.isExport) {
                    queryObject.isExport = this.isExport;
                    queryObject.exportType = this.exportType;
                }

                return queryObject;
            },
            initPage(ifGrid) {
                // 1: draft, 2: inbox, 6: sent, 8: archive, 9: followup
                if (document.querySelectorAll('.v-application--is-rtl').length)
                    this.isLanguageEn = false

                if (ifGrid == 0) {
                    this.pageIndex = 0
                }
                
                this.getItemsForSelectedInbox(true)
            },
            getItemsForSelectedInbox(isResetPaging) 
            {
                if (isResetPaging) {
                    this.pagingData.pageIndex = 0;
                }

                var query = this.prepareSearchAndExportQuery();
                if (!this.hideSpinner)
                    window.showLoading();

                axios.post(constants.baseApiUrl + `Transfer/AdvancedSearch`, query)
                    .then((res) => {
                        if (utils.CheckIfNullOrEmpty(res)) {
                            window.showAlert('res_Msgs_ErrorOccured', 'error')
                            return;
                        }

                        this.correspondences = [];
                        this.correspondences = res.data
                        
                        if (this.shouldShowExpand()){
                            this.correspondences = this.createUniqueList(res.data);
                            this.nonGroupedCorrespondences = res.data;
                        }
                        
                        query.getCountOnly = true.toString();
                        axios.post(constants.baseApiUrl + `Transfer/AdvancedSearch`, query)
                            .then((res) => {
                                if (!utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id)) {
                                    var index = this.inboxes.findIndex(x => x.id == this.selected_node.id)
                                    this.inboxes[index].count = res.data != "" ? res.data : 0;
                                }
                                else
                                    this.inboxes[0].count = res.data != "" ? res.data : 0;
                            });

                        setTimeout(() => { this.showTooltips() }, 1000);
                    })
                    .catch((err) => console.log(err))
                    .finally(() =>
                        !this.hideSpinner ? window.hideLoading() : this.hideSpinner = !this.hideSpinner
                    )
            },
            getItemsCountForSelectedInbox(nodeId, delegationId, successHandler) {
                var formData = new FormData();
                formData.append('nodeId', nodeId)
                formData.append('delegationId', delegationId)
                formData.append('pageIndex', this.pagingData.pageIndex)
                formData.append('pageSize', this.pagingData.pageSize)
                formData.append('getCountOnly', true)

                axios.post(constants.baseApiUrl + 'Transfer/List', formData)
                    .then((res) => {
                        successHandler(res.data)
                    });
            },
            getPinned(item) {
                // if (item.pinned)
                //     return 'mdi-pin'
                // else
                //     return 'mdi-light-pin'
                var isNotRead = (this.getRowClass(item).lastIndexOf('tr-bold') != -1 ? true : false)
                if (isNotRead)
                    return 'mdi-not-read'
                else
                    return ''
            },
            getStatusClass(item) {
                if (constants.statusesEnum.Completed.value == item.statusId)
                    return constants.statusesEnum.Completed.data().classColor;

                return '';
            },
            getAttachment(hasAttachment) {
                if (hasAttachment == true) return 'mdi-attachment'
            },
            previewCorrespondence(item, row) {
                if (!item.openedForPreview) {
                    item.openedForPreview = true;
                }

                this.selected = []
                this.selectedItem = { 'item': item, 'value': true }
                this.openPreviewPane = true

                if (item.attachmentId == null || item.attachmentId == undefined) {
                    this.empty_viewer = true
                }
                else {
                    this.empty_viewer = false
                    window.setViewerData(item.attachmentId, item.documentId);
                    this.viewerFrame = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '&defaultScale=page-fit&pageMode=view' +
                        '&viewerMode=collapsed&r=' + new Date().getTime()
                }
            },
            openFullView() {
                //  Draft = 1, Inbox = 2, Sent = 6, Archived = 8, Follow-up = 9
                this.viewMode = 'readonly'

                var item = this.selectedItem.item
                if (item.statusId == 1) // Draft
                {
                    this.delegationId = 0
                    this.documentId = item.id
                    this.correspondenceDialog = true
                }
                else {
                    this.delegationId = this.selected_node.delegationId
                    this.transferId = item.transferId
                    this.documentId = item.documentId
                    this.correspondenceDialog = true
                    setTimeout(() => {
                        //document.getElementById('correspondenceDialogEmptyDiv').parentElement.classList.add('view-mode-dialog');
                        document.getElementById('correspondenceDialogEmptyDiv').parentElement.parentElement.classList.add('transparentBg');
                    }, 10);
                }

                if (this.nodeId == 9) {
                    this.toEmail = item.sentToEmail
                    this.emailCC = item.sentToManagerEmail
                }

                this.closePreview();
            },
            itemSelected(item, value) {
                if (item.value == true) {
                    this.selectedItem = item
                }
                else {
                    this.selectedItem = null
                }
            },
            closePreview() {
                this.selectedItem = null
                this.openPreviewPane = false
            },
            refreshPage() {
                this.selected = []
                this.closePreview();
                this.initPage(0);
            },
            refreshPageGrid() {
                this.selected = []
                this.selectedItem = null
                this.filters.enableAdvancedSearch = false;
                this.initPage(1);
            },
            getInboxName(isLanguageEn, isDelegation) {
                switch (this.nodeId) {
                    case 1:
                        return isLanguageEn ? 'Draft' : 'المسودات';
                    case 2:
                        return isLanguageEn ? 'Inbox' : 'الوارد';
                    case 6:
                        return isLanguageEn ? 'Sent' : 'المرسل';
                    case 7:
                        return isLanguageEn ? 'Hidden' : 'المخفي';
                    case 8:
                        return isLanguageEn ? 'Archive' : 'الأرشيف';
                    case 9:
                        return isLanguageEn ? 'Follow up' : 'متابعة';
                    case 10:
                        return isLanguageEn ? 'Cced Inbox' : 'النسخ';
                    default:
                        return 'Inbox'
                }
            },
            closeCorrespondenceDialog() {
                this.delegationId = 0
                this.documentId = 0
                this.transferId = 0
                this.correspondenceDialog = false

                this.initPage(0)
            },
            openDeliveryNote() {
                this.documentId = this.selectedItem.item.documentId;

                axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteData?documentId=' + this.documentId)
                    .then((res) => {
                        if (res.data == true) {
                            window.showAlert('res_Msgs_DeliveryNoteCreationValidation', 'warning')
                        }
                        else {
                            this.referenceNumber = this.selectedItem.item.referenceNumber;
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getRowClass(item) {
                var retVal = ''
                if (item.openedDate || item.closedDate || item.openedForPreview || this.nodeId != 2)
                    retVal = ''
                else
                    retVal = 'tr-bold'

                if (this.selectedItem != null && this.selectedItem.item != null && item == this.selectedItem.item) {
                    this.selectedItem.value = true
                    retVal += 'custom-class'
                }

                return retVal
            },
            showTooltip(text) {
                const element = this.$refs.ellipsisElements;
                if (element) {
                    element.textContent = text;
                    return element.offsetHeight < element.scrollHeight;
                }

                return false;
            },
            showTooltips() {
                var elements = document.getElementsByClassName('td-text-limit');
                for (var i = 0; i < elements.length;) {
                    var element1 = elements[i];
                    var element2 = elements[i + 1];
                    var showTooltip = element1.offsetHeight < element1.scrollHeight;
                    if (element1.id.lastIndexOf('ellipsisElements') != -1 && element2.id.lastIndexOf('ellipsisElements') != -1) {
                        if (showTooltip) {
                            element1.style.display = 'none';
                            element2.style.display = '-webkit-box';
                        }
                        else {
                            element1.style.display = '-webkit-box';
                            element2.style.display = 'none';
                        }
                    }

                    i = i + 2;
                }
            },
            updateSortBy(column) {
                this.sortBy = column;
                this.sortDesc = false;

                this.selectedItem = null
                this.getItemsForSelectedInbox(true);
            },
            updateSortDesc(desc) {
                this.sortDesc = desc;

                this.selectedItem = null

                this.getItemsForSelectedInbox(true)
            },
            pageIndexChanged(pagingData) { 
                this.pagingData.pageSize = pagingData.pageSize;
                this.pagingData.pageIndex = pagingData.pageIndex;

                this.getItemsForSelectedInbox(false);
            },
            async openDynamicFormsFilterDialog() {
                this.showDynamicFormsFilterDialog = true;
                this.showStructureFormRender = true;
                setTimeout(() => {
                    this.filterByStructureIdAndCategoryId.structureId = this.currentUserStructureId;
                    this.$refs.formStructureAndCategory.generateHtmlForForm();
                }, 100);
                await axios.get(constants.baseApiUrl + 'DynamicForms/GetTemplateIdsHaveDynamicForms')
                    .then((res) => {
                        if (!utils.CheckIfNullOrEmpty(res) && res.data.length > 0) {

                            for (var index = 0; index < res.data.length; index++) {
                                let object = {
                                    dynamicFormByTemplateId: 'dynamicFormByTemplateId_' + index,
                                    filterByTemplateId: { id: '', templateName: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: res.data[index], url: constants.baseApiUrl, isEditable: true },
                                }
                                this.templateRenderObjects.push(object);
                            }
                            //
                            this.showTemplateFormsRender = true;
                            setTimeout(() => {
                                this.generateHtmlForAllTemplateForms();
                            }, 100);
                        }
                    })
                    .catch((err) => { console.log(err); })
            },
            async generateHtmlForAllTemplateForms() {
                for (let index = 0; index < this.templateRenderObjects.length; index++) {
                    let dynamicFormRef = this.$refs['dynamicForm_' + index];
                    if (dynamicFormRef[0]) {
                        await dynamicFormRef[0].generateHtmlForForm();
                    }
                }
            },
            getUserStructures() {
                axios.post(constants.baseApiUrl + 'StructureUser/GetCurrentUserStructures', null)
                    .then(response => {
                        if (response && response.data.length > 0) {
                            this.currentUserStructureId = response.data[0].structureId;
                        }
                    })
                    .catch(error => console.log(error))
                    .finally(() => this.loading = false);
            },
            applyMoreFilters() {

            },
            validateDate(dateToRemove) {
                if (this.filter_obj.fromDate && this.filter_obj.toDate) {
                    if (this.filter_obj.fromDate > this.filter_obj.toDate) {
                        window.showAlert("res_Msgs_FromDateCompare", "warning");
                        if (dateToRemove == 'to') {
                            this.filter_obj.toDate = ''
                        } else {
                            this.filter_obj.fromDate = ''
                        }
                    }
                }
            },
            shouldShowExpand() {
                return constants.expandSentInboxRowFeature == "true";
            },
            getDynamicList(correspondence) {
                const items = this.nonGroupedCorrespondences
                .filter((elem) => elem.documentId === correspondence.documentId);
                return items ? items : [];
            },
            createUniqueList(correspondencesList) {
                const uniqueList = [];
                const seen = new Set();
                
                for (const item of correspondencesList) {
                    // Normalize the key, treating null as a unique string
                     const uniqueKey = `${item.documentId}`;
                     // const uniqueKey = `${item.documentId}-${item.transferId ?? "null"}`;
                      
                    if (!seen.has(uniqueKey)) {
                    seen.add(uniqueKey);
                    uniqueList.push(item);
                    }
                }

                console.log("Unique List:", uniqueList);
                return uniqueList; // Optional if you need the list later
            }
        },
        computed: {
            filteredHeaders() {
                console.log("this.nodeId:" + this.nodeId)
                // For advanced search, we'll use the inbox headers by default
                // You can customize this based on your needs
                return this.expanded_headers;
            }
        },
        watch: 
		{
			$route() 
			{
                this.clearAndResetFilters();
                this.privacies = constants.privacies;
                this.priorities = constants.priorities;
                this.getUserStructures();

                if (this.$route.query.fromSession) 
                {
                    if (!utils.CheckIfNullOrEmpty(sessionStorage.getItem('advanced_search_filters'))) {
                        this.filters = utils.copyObject(JSON.parse(sessionStorage.getItem('advanced_search_filters')),this.filters);
                        sessionStorage.setItem('advanced_search_filters', '');
                    }
                }

                this.applyFilters();
			}
		}
    }
</script>

<style>
    .v-popper--theme-tooltip {
        max-width: 400px !important;
    }

    .tr-bold td {
        font-weight: 600 !important;
    }

    .show-tooltip {
        /* Add your tooltip styles here */
        /* For example: */
        position: relative;
        cursor: pointer;
    }

    .show-tooltip::before {
        content: attr(title);
        position: absolute;
        top: -20px;
        left: 0;
        background-color: #000;
        color: #fff;
        padding: 5px;
        border-radius: 3px;
        opacity: 0.8;
        /* Additional tooltip styling */
    }

    .inbox_tab_name {
        text-transform: none !important;
    }

    tr.custom-class {
        background: #F0F8FF;
    }

    tr.custom-class .v-icon.mdi-checkbox-blank-outline:before {
        content: "";
        width: 20px;
        height: 20px;
        border: none;
        border-radius: 4px;
        background-color: #205cdf;
        background-image: url(../assets/images/icons/tick.svg);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 10px;
    }

    #viewerFrame {
        height: calc(100% - 39px);
    }

    /* .v-dialog__content.v-dialog__content--active {
        background: transparent !important;
    } */

    .transparentBg {
        background: transparent !important;
    }

    .custom-button {
        background: none !important;
        padding: 0 !important;
        margin: 0 !important;
    }

    .expanded-item-container {
        margin: 0;
        padding: 0;
    }

    .expanded-item-table {
        width: 100%;
        margin: 0;
        padding: 0;
        border: 0px;
    }

    /* Target the td that contains the expanded content */
    .v-data-table__expanded td {
        padding: 0 !important;
    }
</style>